import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface TrashIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const TrashIcon: React.FC<TrashIconProps> = ({
  size = 16,
  color = 'iconNegative',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12" fill="none">
      <Path
        d="M3.17647 12H8.82353C9.70887 12 10.2054 11.5919 10.2413 10.8233L10.6241 3.22792H11.3958C11.7368 3.22792 12 3 12 2.69788C12 2.40106 11.7368 2.17314 11.3958 2.17314H8.85344V1.39399C8.85344 0.514134 8.22532 0 7.13659 0H4.85743C3.76869 0 3.1346 0.514134 3.1346 1.39399V2.17314H0.604187C0.269192 2.17314 0 2.40106 0 2.69788C0 3 0.269192 3.22792 0.604187 3.22792H1.38185L1.75872 10.8233C1.79462 11.5919 2.29711 12 3.17647 12ZM4.50449 1.4364C4.50449 1.21908 4.67198 1.08127 4.94716 1.08127H7.04686C7.32203 1.08127 7.48953 1.21908 7.48953 1.4364V2.17314H4.50449V1.4364ZM4.06181 10.288C3.80459 10.288 3.62512 10.1343 3.61914 9.90636L3.43968 4.38339C3.4337 4.15548 3.60718 4.00177 3.87637 4.00177C4.13958 4.00177 4.32503 4.15018 4.33101 4.37809L4.51047 9.90106C4.51645 10.129 4.33699 10.288 4.06181 10.288ZM6 10.288C5.73081 10.288 5.55135 10.1343 5.55135 9.90636V4.37809C5.55135 4.15548 5.73081 4.00177 6 4.00177C6.26919 4.00177 6.44865 4.15548 6.44865 4.37809V9.90636C6.44865 10.1343 6.26919 10.288 6 10.288ZM7.93819 10.288C7.65703 10.288 7.48355 10.129 7.48953 9.90106L7.66899 4.38339C7.67497 4.15548 7.86042 4.00177 8.12363 4.00177C8.39282 4.00177 8.5663 4.15548 8.56032 4.38339L8.38086 9.90636C8.37488 10.1343 8.19541 10.288 7.93819 10.288Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

TrashIcon.displayName = 'TrashIcon';
